enum AddStudentModalStack {
  AddStudent = 'add-student',
  StudentAdded = 'student-added',
}

export { AddStudentModalStack };
